// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"629506b5","404":"2fd1372e","477":"e16aeed4","916":"0779c6ab"}[chunkId] + ".chunk.js";
};